var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('h1',[_vm._v(_vm._s(_vm.$t('message.tasas.menu.consultarPagos.titulo')))]),_c('v-form',{ref:"formFiltro",attrs:{"lazy-validation":""}},[_c('v-container',{staticClass:"search",attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"placeholder":_vm.$t('message.comun.textoBusqueda'),"append-outer-icon":"search","solo":"","clearable":""},model:{value:(_vm.filtroTabla),callback:function ($$v) {_vm.filtroTabla=$$v},expression:"filtroTabla"}})],1)],1)],1)],1),_c('v-data-table',{attrs:{"id":"resultadosTabla","headers":this.empresaSelected && this.empresaSelected.cdtipemp === 'P'
        ? [
            {
              value: 'fefinfacPublic',
              text: this.$t('message.comun.mesPerido'),
              align: 'center',
              sortable: false
            },
            {
              value: 'fepresenPublic',
              text: this.$t('message.comun.fechaNotificacion'),
              align: 'center',
              sortable: false
            },
            {
              value: 'nujustas',
              text: this.$t('message.comun.justificante.numero'),
              align: 'center',
              sortable: true
            },
            {
              value: 'imp',
              text: this.$t('message.comun.importeTotal'),
              align: 'center',
              sortable: false
            },
            {
              value: 'actions',
              text: this.$t('message.tasas.periodo.actions'),
              align: 'center',
              sortable: false
            }
          ]
        : [
            {
              value: 'feperdecPublic',
              text: this.$t('message.comun.mesDeclaracion'),
              align: 'center',
              sortable: false
            },
            {
              value: 'fefinfacPublic',
              text: this.$t('message.comun.mesFacturacion'),
              align: 'center',
              sortable: false
            },
            {
              value: 'fepresenPublic',
              text: this.$t('message.comun.fechaPresentacion'),
              align: 'center',
              sortable: false
            },
            {
              value: 'cdregist',
              text: this.$t('message.comun.justificante.codigoRegistro'),
              align: 'center',
              sortable: true
            },
            {
              value: 'nujustas',
              text: this.$t('message.comun.justificante.numero'),
              align: 'center',
              sortable: true
            },
            {
              value: 'imp',
              text: this.$t('message.comun.importeTotal'),
              align: 'center',
              sortable: false
            },
            {
              value: 'actions',
              text: this.$t('message.tasas.periodo.actions'),
              align: 'center',
              sortable: false
            }
          ],"items":_vm.declaraciones,"no-data-text":_vm.$t('message.comun.sinDeclaracion'),"no-results-text":_vm.$t('message.comun.sinResultadosBusqueda'),"search":_vm.filtroTabla,"pagination":_vm.pagination},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [(_vm.empresaSelected.cdtipemp !== 'P')?_c('td',{staticClass:"text-xs-center"},[_vm._v("\n        "+_vm._s(props.item.feperdecPublic)+"\n      ")]):_vm._e(),_c('td',{staticClass:"text-xs-center"},[_vm._v("\n        "+_vm._s(props.item.fefinfacPublic)+"\n      ")]),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.fepresenPublic))]),(_vm.empresaSelected.cdtipemp !== 'P')?_c('td',{staticClass:"text-xs-center"},[_vm._v("\n        "+_vm._s(props.item.cdregist)+"\n      ")]):_vm._e(),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.nujustas))]),_c('td',{staticClass:"text-xs-center"},[_c('Numeric',{attrs:{"id":'importe' + props.item.id,"value":props.item.nueurtot,"currency":"€","readonly":""}})],1),_c('td',{staticClass:"text-xs-center"},[_c('Icono',{staticClass:"mr-2",attrs:{"id":'consulta' + props.item.id,"payload":props.item,"color":"success","tooltip":_vm.$t('message.comun.consultarDeclaracion.tooltipRegistro')},on:{"click":_vm.consultarDeclarateHandler}},[_vm._v("play_circle_filled\n        ")])],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }